export const IconArrowFoward = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconArrowFoward_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconArrowFoward_svg__a)">
        <path d="M16.175 13H5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 12q0-.424.287-.713A.97.97 0 0 1 5 11h11.175l-4.9-4.9a.92.92 0 0 1-.287-.7Q11 5 11.3 4.7q.3-.275.7-.288t.7.288l6.6 6.6q.15.15.212.325.063.175.063.375t-.062.375a.9.9 0 0 1-.213.325l-6.6 6.6a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.713 0-.412.3-.712z" />
      </g>
    </svg>
  );
};
